import { ExternalLink } from "~/components/site/external-link";

type Props = Readonly<{
  sources: readonly string[];
}>;

export function Sources({ sources }: Props): JSX.Element {
  return sources.length ? (
    <div className="flex not-prose">
      <div className="flex ml-auto gap-x-2 text-gray-500 text-xs mr-1 mt-1">
        {sources.map((s) => (
          <ExternalLink className="link" key={s} href={s}>
            Source
          </ExternalLink>
        ))}
      </div>
    </div>
  ) : (
    <></>
  );
}
